export default __webpack_public_path__ + "static/media/part_1.07affe62.png";